export default {
  CUSTOMER_ADDRESSES: 'CUSTOMER_ADDRESSES',
  CUSTOMER_BILLING_ADDRESS: 'CUSTOMER_BILLING_ADDRESS',
  CUSTOMER_RELATIONSHIPS: 'CUSTOMER_RELATIONSHIPS',
  CUSTOMER_INCLUDED: 'CUSTOMER_INCLUDED',
  CUSTOMER_DELIVERY_ADDRESSES: 'CUSTOMER_DELIVERY_ADDRESSES',
  CUSTOMER_DELIVERY_ADDRESSES_SAP: 'CUSTOMER_DELIVERY_ADDRESSES_SAP',
  CUSTOMER_DEFAULT_DELIVERY_ADDRESS: 'CUSTOMER_DEFAULT_DELIVERY_ADDRESS',
  CUSTOMER_DELIVERY_ADDRESSES_FORMATTED: 'CUSTOMER_DELIVERY_ADDRESSES_FORMATTED',
  CUSTOMER_DELIVERY_ADDRESSES_FORMATTED_SAP: 'CUSTOMER_DELIVERY_ADDRESSES_FORMATTED_SAP',
  CUSTOMER_SELECTED_DELIVERY_ADDRESS_FORMATTED: 'CUSTOMER_SELECTED_DELIVERY_ADDRESS_FORMATTED',
  CUSTOMER_DELIVERY_ADDRESSES_BASKET: 'CUSTOMER_DELIVERY_ADDRESSES_BASKET',
  CUSTOMER_DELIVERY_ADDRESS_BASKET: 'CUSTOMER_DELIVERY_ADDRESS_BASKET',
  CUSTOMER_PARENT_PAYMENT_ADDRESS: 'CUSTOMER_PARENT_PAYMENT_ADDRESS',
  CUSTOMER_PAYMENT_ADDRESS: 'CUSTOMER_PAYMENT_ADDRESS',
  CUSTOMER_PAYMENT_ADDRESS_BASKET: 'CUSTOMER_PAYMENT_ADDRESS_BASKET',
  CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS: 'CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS',
  CUSTOMER_PAYMENT_ADDRESS_MISSING_DATA: 'CUSTOMER_PAYMENT_ADDRESS_MISSING_DATA',
}
